import styledComp from 'styled-components';

export const ListContainer = styledComp.div`
  max-height: 720px;
  min-height: 20px; // min-height is set so that empty scrollbar is not shown when "No assets" message is displayed
  overflow: auto;
`;
